import cabri from "../../app/cabri-app";
import * as BABYLON from "babylonjs/babylon.max";


let receivedState = null;
let horizontalHintMeshes = null

/**
 * Methods to provide visual hints informing about the move (vertical, horizontal, ...)
 */
function displayVerticalMoveHint() {
    let pZ = cabri.lastPointerCoord.z
    if (horizontalHintMeshes === null)
        horizontalHintMeshes = createHorizontalHintMeshes();
    horizontalHintMeshes.vertHint.scaling.y = pZ>0 ? 1 : -1     // to "reverse" top-bottom the vertical hint
    hideHigherSegs(pZ>0 ? pZ : -pZ)              // arg of hideHigherSegs() supposed to be >0
}

function displayHorizontalMoveHint() {
    if(cabri.lastPointerCoord) {
        if (horizontalHintMeshes === null)
            horizontalHintMeshes = createHorizontalHintMeshes();
        const p = cabri.lastPointerCoord

        horizontalHintMeshes.position.x = Math.round(p.x)
        horizontalHintMeshes.position.z = Math.round(p.y)

        cabri.scene.useOrderIndependentTransparency = false;
        horizontalHintMeshes.setEnabled(true)
// and now the vert hint as needed:
        let alt = p.z >0 ? p.z : -p.z
        if (alt < 10e-12)
            alt = 0             // forced to be exactly on xoy plane....
        if (alt) {
            horizontalHintMeshes.vertHint.scaling.y = p.z>0 ? 1 : -1  // to be top-down reversed
            horizontalHintMeshes.vertHint.setEnabled(true)
            horizontalHintMeshes.vertHint.position.x = p.x
            horizontalHintMeshes.vertHint.position.z = p.y
            hideHigherSegs(p.z>0 ? p.z: -p.z)    // arg of hideHigherSegs() supposed to be >0
        }
        else
            horizontalHintMeshes.vertHint.setEnabled(false)
    }
}

/**
 *
 * @param absZ     hides in vertical hint segments higher>absZ
 */
function hideHigherSegs(absZ) {     // absZ is the absolute value of z
    let index = Math.round(absZ)
    let segment = horizontalHintMeshes.vertHint.segs[index]
    segment.setEnabled(false)                                   // it disables also the base octahedron
    for (var i=index-1; i>=0 ; i--)
        horizontalHintMeshes.vertHint.segs[i].setEnabled(true)  // it enables also the base octahedron
}


function stateChanged(state,evt) {
    let constrained = false;
    if (evt && evt.touchedGeomObject && evt.touchedGeomObject.objectId) {
        constrained = cabri.emsc.getControllingRelationClass(
            evt.touchedGeomObject.objectId).indexOf("_on_") > -1;
    }
    if (state.endsWith("_moving_horizontal") && !constrained)
        displayHorizontalMoveHint();
    else if (state.endsWith("_moving_vertical") && !constrained)
        displayVerticalMoveHint()
    else if (horizontalHintMeshes) {
        cabri.scene.useOrderIndependentTransparency = true;
        horizontalHintMeshes.setEnabled(false)
        horizontalHintMeshes.vertHint.setEnabled(false)
    }
    receivedState = state;
}


/** *********first time hints creation :*********** height is 12 *************************/
/**
 *
 * @returns {LinesMesh}     q mesh of orthogonal dashed lines of length 12, (main dashed line with children)
 */
function createHorizontalHintMeshes() {
    //24 points  [0,...-23]   versus in case of solid only 2 points....   [0,1]
    let line = BABYLON.MeshBuilder.CreateDashedLines("horiz", {
        points: [new BABYLON.Vector3(-3 + 0.05, 0, 0),
                 new BABYLON.Vector3(3 + 0.05, 0, 0)],
        dashSize: 4, gapSize: 1, dashNb: 12})
    line.renderingGroupId = 1
    line.color = BABYLON.Color3.Black() //Red()

    let xLine
    let nb = 2
    for (var i = -nb; i <= nb; i++) {
        if (i) {
            xLine = line.createInstance("")
            xLine.parent = line
            xLine.position.z = i
        }
    }
    let zLine
    for (var i = -nb; i <= nb; i++) {
        zLine = line.createInstance("")
        zLine.rotation.y = Math.PI / 2
        zLine.parent = line
        zLine.position.x = i
    }
    line.cabriScene = window.cabri.scene
    line.vertHint = createVerticalHintMeshes(12)
    line.vertHint.setEnabled(false)         // vert. hint initially not visible
    return line;
}

/**
 *
 * @param height            max number of unit segments in vertical hint
 * @returns {LinesMesh}     actually a segment starting at (0,0,0) with children (segments and small octahedra)
 */
function createVerticalHintMeshes(height) {
    let size1Vseg = BABYLON.MeshBuilder.CreateDashedLines("seg0", {
        points: [new BABYLON.Vector3(0, 0.05, 0),
                 new BABYLON.Vector3(0, 1.05, 0)],
        dashSize: 4, gapSize: 1, dashNb: 2})
    size1Vseg.renderingGroupId = 1
    size1Vseg.color = BABYLON.Color3.Black()
    let octah = createOctaedron(0.1)
    octah.parent = size1Vseg            // each size1seg has an octahedron as basis
    octah.isVisible = false

    size1Vseg.segs = []
    let lastParent = size1Vseg
    for (var i= 1; i<height; i++) {
        let vLineInst = size1Vseg.createInstance("seg-"+i)
// each new  vLineInst has the preceding parent aka lastParent (=> easy to retrieve for hiding)
        vLineInst.parent = lastParent
        lastParent = vLineInst
        vLineInst.position.y = 1
        size1Vseg.segs[i-1] = vLineInst     // to access the successive (height) segments
                                            // and hide them easily as needed
       // putting on octahedron up to the last line segment
        let octahInst = octah.createInstance("o-"+i)
        octahInst.isVisible = true
        octahInst.parent = vLineInst    // its parent is the current segment
    }
    return size1Vseg;
}

/**
 *
 * @param edge      size (edge) of (0,0,0) centred octahedron
 * @returns {*}     a mesh without material shaping an octahedron
 */
function createOctaedron(edge) {
    let octa = new BABYLON.Mesh('octah');             // CREATION
    let vertexData = new BABYLON.VertexData();
    const hE = 1/2,                     // half edge
          hD = hE * Math.sqrt(2)     // half diagonal
    vertexData.positions = [-hE,0,-hE,  hE,0,-hE,  hE,0,hE,  -hE,0,hE,   0,hD,0, 0,-hD,0];
    vertexData.indices = [4,0,1,  4,1,2,  4,2,3, 4,3,0,
                          5,1,0,  5,2,1,  5,3,2, 5,0,3];
    vertexData.normals = [];
    BABYLON.VertexData.ComputeNormals(vertexData.positions, vertexData.indices, vertexData.normals);

    octa.scaling.x = octa.scaling.y = octa.scaling.z = edge;
    vertexData.applyToMesh(octa);
    return octa;
}

export default
    {stateChanged}